import { Form } from '../core'

$.fn.LoginForm = function() {
  let self = this
  self.form = undefined

  self.initialize_form = function() {
    self.form = new Form(self.get(0), {
      use_ajax: false,
      auto_scroll: false,
      floating_labels: true,
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}
